import React from 'react';
import { Box, Form, OptionType, Text, useAnalytics } from '@medely/ui-kit';
import useSpecialtiesMutations from '@mp/hooks/useSpecialtiesMutations';
import { recommendedSpecialtiesFormSchema } from './recommendedSpecialtiesFormSchema';
import { useCurrentUser, useGate, useSpecialtyTracking } from '@mp/hooks';
import { gateNames } from '@mp/constants';
import { RecommendedSpecialtiesForm } from './RecommendedSpecialtiesForm';

type RecommendedSpecialtiesInfoProps = {
  options: OptionType[];
  handleContinueClick: () => void;
  onClose: () => void;
};

type ValuesType = {
  add_specialty_ids: number[];
};

export const RecommendedSpecialtiesInfo = ({
  options,
  handleContinueClick,
  onClose,
}: RecommendedSpecialtiesInfoProps) => {
  const analytics = useAnalytics();
  const { currentUser } = useCurrentUser();
  const { trackSpecialtyRequirementsModalInteract } = useSpecialtyTracking(analytics);
  const { submitSpecialtiesInfo, isSpecialtiesLoading } = useSpecialtiesMutations();
  const showSpecialtySpeedbumpExtension = useGate(gateNames.specialty_speedbump_extension);

  const speedBumpExtensionMessage =
    "This shift requires skills that aren't on your profile. You must have experience in these areas to book this shift. Select any relevant specialties to add to continue booking.";
  const legacySpeedBumpMessage =
    'This shift requires skills that aren’t on your profile. Select any relevant ones to add now. You must have experience in these areas to work this shift.';

  const defaultValues = {
    add_specialty_ids: [] as number[],
  };

  const professionalId = currentUser?.professional?.id;

  const handleSubmit = (values: ValuesType) => {
    const specialtiesToAddIds = values.add_specialty_ids;
    trackSpecialtyRequirementsModalInteract(professionalId, specialtiesToAddIds);
    submitSpecialtiesInfo(values, {
      onSuccess: () => {
        handleContinueClick();
        onClose();
      },
    });
  };

  return (
    <Box testId="recommended-specialties-info">
      <Text size="m" color="text.primary" testId="recommended-specialties-info-text">
        {showSpecialtySpeedbumpExtension ? speedBumpExtensionMessage : legacySpeedBumpMessage}
      </Text>
      <Form
        handleSubmit={handleSubmit}
        schema={recommendedSpecialtiesFormSchema}
        defaultValues={defaultValues}
      >
        <RecommendedSpecialtiesForm
          options={options}
          isSpecialtiesLoading={isSpecialtiesLoading}
          showSpecialtySpeedbumExtension={showSpecialtySpeedbumpExtension}
        />
      </Form>
    </Box>
  );
};
